import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppStateService } from '../../services/app-state.service';
import { AppInfo } from '../../models/platfrom';
import { VersionForVisuallyImpairedRoutes } from '../../../../models/routes';

@Component({
  selector: 'app-app-card',
  templateUrl: './app-card.component.html',
  styleUrls: ['./app-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppCardComponent implements OnInit {
  private _appId: string;
  public allApps$: Observable<AppInfo[]>;
  public currentApp: AppInfo | undefined;
  public routChanged$: Observable<any>;
  public backLink = `/visually-impaired/${VersionForVisuallyImpairedRoutes.Apps}`;
  constructor(public appState: AppStateService, private activateRoute: ActivatedRoute, private cdr: ChangeDetectorRef, private router: Router) {}

  private changeApp(appId: string | null) {
    this.allApps$ = this.appState.getAllPlatforms().pipe(
      tap(apps => {
        if (appId) {
          this._appId = appId;
          this.currentApp = apps.find(a => a.id === +appId);
          this.cdr.detectChanges();
        }
      })
    );
  }

  public ngOnInit(): void {
    const appId = this.activateRoute.snapshot.paramMap.get('id');

    this.routChanged$ = this.router.events.pipe(
      tap(event => {
        if (event instanceof NavigationEnd) {
          const newAppid = event.url.split('/')[3];
          if (newAppid && newAppid !== this._appId) {
            this.changeApp(newAppid);
          }
        }
      })
    );
    this.changeApp(appId);
  }
}
